import axios from 'axios';

export const upload = async ({ index, file }) => {
    const formData = new FormData();
    formData.append('image', file);

    try {
        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/upload/trader`, formData,
        {
            params: { index },
            withCredentials: true,
            headers: {
            Accept: 'application/json',
            },
        });
        return data;
    } catch (error) {
        return null;
        //console.error('❌ Erreur lors de l’upload de l’image :', error.message);
    }
};

export const erase = async ({ index }) => {
    try {
        const { data } = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/upload/trader`,
        {
            params: { index },
            withCredentials: true,
            validateStatus: () => true,
            headers: {
            Accept: 'application/json',
            },
        });
        return data;
    } catch (error) {
         return null;
        //console.error('❌ Erreur lors de la suppression de l’image :', error.message);
    }
};
